"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const theme_1 = require("@obvio/app/theme/");
const colors = {
    primary: (0, theme_1.createColor)("#1C4F4A", {
        dark: "#07342F",
    }),
    secondary: (0, theme_1.createColor)("#C8CD0B", {}),
    additional: [(0, theme_1.createColor)("#B7D0DC", {}), (0, theme_1.createColor)("#F7F3EA", {})],
};
exports.default = (0, theme_1.createTheme)({
    colors,
    page: {
        width: "82rem",
        center: true,
        sectionSpacing: {
            desktop: "10rem",
            notDesktop: "7.5rem",
        },
        margin: {
            notDesktop: "1.25rem",
            desktop: "2rem",
        },
    },
    font: "var(--font-family-writer)",
    secondaryFont: "var(--font-family-factor)",
    stroke: "#E1E1E1",
    background: "#000000",
    radius: {
        big: "4rem",
        small: "2rem",
    },
    modal: {
        css: (0, theme_1.css) `
      width: 100vw;
      height: 100vh;
      height: 100dvh;
      max-height: 100vh !important;
      border-radius: 0;
      > header {
        position: absolute;
        right: 0;
        top: 0;
        z-index: 1;
      }
      > section {
        padding: 0;
      }
    `,
    },
    links: {
        css: (0, theme_1.css) `
      font-family: ${(theme) => theme.secondaryFont};
      font-size: 1rem;
      font-weight: 500;
      color: white;
    `,
    },
    typography: {
        css: (0, theme_1.css) `
      font-family: ${(theme) => theme.font};
      white-space: break-spaces;
      color: ${(theme) => theme.colors.primary.dark};
    `,
        note: (0, theme_1.css) `
      font-family: ${(theme) => theme.secondaryFont};
    `,
        h1: (0, theme_1.css) `
      font-size: 8rem;
      line-height: 105%;
      font-weight: 400;
      letter-spacing: 0.005em;
      @media ${theme_1.notDesktop} {
        font-size: 2rem;
      }
    `,
        h2: (0, theme_1.css) `
      font-weight: 400;
      font-size: 3rem;
      line-height: 125%;
      letter-spacing: 0.005em;
      @media ${theme_1.notDesktop} {
        font-size: 2rem;
        line-height: 120%;
      }
    `,
        h3: (0, theme_1.css) `
      font-weight: 400;
      font-size: 2rem;
      letter-spacing: -0.04rem;
      @media ${theme_1.notDesktop} {
        font-size: 1.5rem;
      }
    `,
        "sub-h1": (0, theme_1.css) `
      font-family: ${(theme) => theme.secondaryFont};
      font-weight: 400;
      font-size: 1rem;
      line-height: 157%;
      letter-spacing: 0.005em;
    `,
        "sub-h2": (0, theme_1.css) `
      font-weight: 400;
      font-size: 2rem;
      line-height: 110%;
      letter-spacing: 0.005em;
    `,
        "sub-h3": (0, theme_1.css) `
      font-weight: 400;
      font-size: 1.5rem;
      line-height: 130%;
      letter-spacing: 0.005em;
    `,
        p: (0, theme_1.css) `
      font-weight: 400;
      font-size: 1rem;
      line-height: 157%;
      letter-spacing: 0.005em;
      font-family: ${(theme) => theme.secondaryFont};
    `,
        "caption-1": (0, theme_1.css) `
      font-weight: 400;
      font-size: 1rem;
      line-height: 157%;
      letter-spacing: 0.005em;
    `,
    },
    inputs: {
        css: (0, theme_1.css) `
      border: none;
      border-radius: 0;
      border-bottom: 0.0625rem solid ${(theme) => theme.stroke};
    `,
        text: {
            css: (0, theme_1.css) `
        height: 4rem;
        input {
          color: ${(theme) => theme.colors.primary};
          font-size: 1.5rem;
        }
        align-items: end !important;
      `,
        },
        textarea: {
            css: (0, theme_1.css) `
        background: transparent;
        height: unset;
        color: white;
        font-size: 1.5rem;
        padding-top: 2rem;
      `,
            label: (0, theme_1.css) `
        top: 1rem;
        bottom: unset;
      `,
        },
        label: (0, theme_1.css) `
      cursor: text;
      z-index: 1;
      font-size: 1rem;
      margin-left: 0.75rem;
      user-select: none;
      position: absolute;
      top: 0.0625rem;
      bottom: 0.0625rem;
      left: 0;
      display: flex;
      align-items: center;
      padding: 0.15rem;
      transition: 150ms all;
      font-size: 1.0625rem;
      margin: 0;
      font-family: var(--font-family-dmSans);
      &.focus-visible,
      &.with-value {
        top: 0.25rem;
        bottom: unset;
        left: 0.5rem;
        font-size: 0.8125rem;
        padding: 0 0.25rem;
      }
    `,
        checkbox: {
            css: (0, theme_1.css) `
        --background: transparent !important;
        --active-inner: transparent !important;
        --active: ${(theme) => theme.colors.primary.dark} !important;
        border-radius: 0 !important;
        border-width: thin;
      `,
            wrapper: (0, theme_1.css) `
        align-items: self-start;
      `,
            label: (0, theme_1.css) `
        transform: none;
        margin-left: 1rem;
        text-align: left;
        font-size: 0.75rem;
        line-height: 1.25rem;
        padding: 0;
        margin-top: -0.25rem;
      `,
        },
    },
    buttons: {
        css: (0, theme_1.css) `
      background: #123330;
      border-radius: ${(theme) => theme.radius.big};
      color: white;
      padding: 1.125rem 2rem;
      font-family: ${(theme) => theme.secondaryFont};
      font-size: 1rem;
      height: 3.5rem;
      :hover {
        border: none;
      }
    `,
        secondary: (0, theme_1.css) `
      background: ${(theme) => theme.colors.secondary};
      border: none;
      :hover {
        text-decoration: underline;
        background: ${(theme) => theme.colors.secondary};
      }
    `,
        transparent: (0, theme_1.css) `
      background: transparent;
    `,
        icon: (0, theme_1.css) `
      background: transparent;
      padding: 0;
      width: 3.5rem;
      min-width: unset;
      @media ${theme_1.mobile} {
        width: 3.5rem;
      }
    `,
    },
    global: (0, theme_1.css) `
    :root {
      --nav-height: 5.5rem;
      @media ${theme_1.mobile} {
        --nav-height: 5rem;
      }
    }
  `,
    context: {
        menu: {
            links: {
                css: (0, theme_1.css) `
          font-size: 1.25rem;
          color: white;
        `,
            },
            buttons: {
                css: (0, theme_1.css) `
          border-radius: calc(${(theme) => theme.radius.small} / 2);
          background: white;
          color: ${(theme) => theme.colors.primary};
          width: 100%;
        `,
            },
            typography: {
                h1: (0, theme_1.css) `
          font-size: 8rem;
          line-height: 105%;
          font-weight: 400;
          letter-spacing: 0.005em;
          @media ${theme_1.notDesktop} {
            font-size: 8rem;
          }
        `,
            },
        },
        blog: {
            page: {
                width: "55rem",
                center: true,
                sectionSpacing: {
                    desktop: "10rem",
                    notDesktop: "7.5rem",
                },
                margin: {
                    notDesktop: "1.25rem",
                    desktop: "2rem",
                },
            },
        },
        black: {
            background: "#000000",
            typography: {
                css: (0, theme_1.css) `
          color: white;
        `,
            },
        },
        white: {
            background: "#ffffff",
            typography: {
                css: (0, theme_1.css) `
          color: ${(theme) => theme.colors.primary.dark};
        `,
            },
            links: {
                css: (0, theme_1.css) `
          color: ${(theme) => theme.colors.primary.dark};
        `,
            },
        },
        green: {
            background: "#123330",
            typography: {
                css: (0, theme_1.css) `
          color: white;
        `,
            },
            inputs: {
                text: {
                    css: (0, theme_1.css) `
            input {
              color: white;
            }
          `,
                },
            },
        },
    },
});
